import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';

import TextArea from 'libs/design-system/src/components/TextArea';
import { Button } from '@unified-checkout/design-system';
import { useLangStore } from '@app/dashboard/store/lang';

import { REACH_PAGE_EVENTS } from '@app/dashboard/constants/tracking_events/reach';
import type { IField } from '@app/dashboard/types/outerLayout/common';
import { CREATE_CAMPAIGN_FIELDS } from '@app/dashboard/constants/reach/modals/create-campaign';

import styles from './SmsDescription.module.scss';

const SmsDescription = ({
  availableAmount,
  usedAmount,
  handleFieldChange,
  fields,
  isCreateLoading,
}: {
  availableAmount: number;
  usedAmount: number;
  handleFieldChange: Function;
  fields: IField;
  isCreateLoading: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useLangStore();

  const handleNavigateToBundles = () => {
    navigate('/reach/bundles');
    amplitude.track(
      REACH_PAGE_EVENTS.CAMPAIGNS_PAGE.CLICK_UPGRADE_FROM_CREATION
    );
  };

  return (
    <div className={styles['reach-create-campaign__body-description']}>
      <div className={styles['reach-create-campaign__body-description-info']}>
        <p
          className={
            styles['reach-create-campaign__body-description-info-title']
          }
        >
          {t('innerLayout.reach.campaigns.header.availableSMS', {
            available: availableAmount,
            total: usedAmount + availableAmount,
          })}
        </p>
        <Button
          text={t('innerLayout.reach.campaigns.header.upgrade')}
          variant="link"
          onClickHandler={handleNavigateToBundles}
          size="sm"
          disabled={isCreateLoading}
        />
      </div>
      <TextArea
        name={CREATE_CAMPAIGN_FIELDS.DESCRIPTION}
        label={t(
          'innerLayout.reach.campaigns.createCampaign.labels.campaignDescription'
        )}
        placeholder={t(
          'innerLayout.reach.campaigns.createCampaign.placeholders.campaignDescription'
        )}
        minLength={0}
        maxLength={500}
        showCharactersCount
        onChange={(e) => {
          handleFieldChange({ event: e });
        }}
        errorMessage={fields[CREATE_CAMPAIGN_FIELDS.DESCRIPTION].errorMsg}
        variant={
          fields[CREATE_CAMPAIGN_FIELDS.DESCRIPTION].errorMsg
            ? 'error'
            : 'default'
        }
        value={fields[CREATE_CAMPAIGN_FIELDS.DESCRIPTION].value}
        defaultValue={fields[CREATE_CAMPAIGN_FIELDS.DESCRIPTION].value}
        lang={lang}
        disabled={isCreateLoading}
      />
    </div>
  );
};

export default SmsDescription;
